const linkInvitationUserCopiedToClipboard = {
  toastr: 'Link',
  toastr1: 'Link copiado al área de transferencia'
};

export default linkInvitationUserCopiedToClipboard;